import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Milestone extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "htmlUrl", Model.attribute('htmlUrl'));
    _defineProperty(this, "title", Model.attribute('title'));
    _defineProperty(this, "state", Model.attribute('state'));
    _defineProperty(this, "openIssues", Model.attribute('openIssues'));
    _defineProperty(this, "closedIssues", Model.attribute('closedIssues'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "dueOn", Model.attribute('dueOn', Model.transformDate));
    _defineProperty(this, "closedAt", Model.attribute('closedAt', Model.transformDate));
  }
}
flarum.reg.add('sycho-github-milestone', 'forum/models/Milestone', Milestone);